module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av496-fb39e8712eacb34c24b33c2c4b070385.jpg";